<template>
  <div style="width: 100%;text-align: left" >
      <qrcode :url="'/h5/#/pages/creation/detail?id='+$route.params.id"></qrcode>
    <nav-header v-if="$route.name=='creationDetail'" />
    <div class="m-auto lg:w-[60%]" style="padding-top: 20px">
      <el-row :gutter="20">
        <el-col :md="24" >
      <div> <h1>{{formLabelAlign.title}}</h1>
        <div class="meta-info">
          <small v-if="formLabelAlign.showTime=='Y' " class="text-muted">创建时间： {{formLabelAlign.createTime}}</small>
          <div class="tags-wrapper" v-if="formLabelAlign.tags && formLabelAlign.tags.length">
            <el-tag
              v-for="tag in formLabelAlign.tags"
              :key="tag"
              size="small"
              effect="plain"
              class="tag-item"
            >
              #{{ tag }}
            </el-tag>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <router-link :to="'/profile/'+userInfo.id  ">
        <el-avatar :src="userInfo.headImageThumb"></el-avatar> </router-link>
        <div style="margin-left: 15px">
          <router-link :to="'/profile/'+userInfo.id  "> <span style="font-weight:700">{{ userInfo.nickName }}</span>  </router-link>
          <i style="font-size: 1.5rem" class="el-icon-chat-dot-round" ref="item" @click="ifShow"></i>
          <div>  <small class="text-muted">{{ userInfo.signature }}</small></div>

        </div>

      </div>
      <hr/>
      <div  v-if="hasPay" class=" alert-danger  border-light">
        <h5 class="text-center">支付成功！ <el-button @click="saveOrder()" type="success" v-if="!hasLogin">保存</el-button>

        </h5>
        <marquee v-if="!hasLogin" behavior="alternate" scrollamount="2" class="pt-2">请尽快使用或保存,如有疑问请联系商家。</marquee>
      </div>
      <div class="introduce" >
          <Editor
              v-model="formLabelAlign.publicContent"
              :defaultConfig="{readOnly :true}"
          />
      </div>
          <el-alert
              effect="dark"
              title="该用户已注销，请谨慎购买"
              type="error" v-if="userInfo?.status!=0">
          </el-alert>
      <div v-if="!hasPay &&formLabelAlign.publicContent" class="col-lg-12 text-center item-solid p-5">
        <div class="text-danger"><h4>￥{{formLabelAlign.amt}}</h4>
        </div>
        <div class="pb-2 text-muted"><img style="display: inline-block; margin: 0; vertical-align: sub;" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTU3NzQwODg0OTY4IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjI1MTczIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik01MDEuMTIgMTYwYTE3NiAxNzYgMCAwIDEgMTc2IDE3NlY0MTZoLTM1MlYzMzZBMTc2IDE3NiAwIDAgMSA1MDEuMTIgMTYwbTAtOTZhMjcyIDI3MiAwIDAgMC0yNzIgMjcyVjUxMmg1NDRWMzM2QTI3MiAyNzIgMCAwIDAgNTAxLjEyIDY0eiIgZmlsbD0iIzY2NjY2NiIgcC1pZD0iMjUxNzQiPjwvcGF0aD48cGF0aCBkPSJNODA4LjMyIDM4NEgxOTJhNzcuNDQgNzcuNDQgMCAwIDAtNzQuODggNzYuOHY0MjIuNEE3Ny40NCA3Ny40NCAwIDAgMCAxOTIgOTYwaDYxMy43NmE3Ni44IDc2LjggMCAwIDAgNzYuOC03Ni44VjQ2MC44QTc2LjggNzYuOCAwIDAgMCA4MDguMzIgMzg0eiBtLTMwNy4yIDM4NGE5NiA5NiAwIDEgMSA5Ni05NiA5NiA5NiAwIDAgMS05NiA5NnoiIGZpbGw9IiM2NjY2NjYiIHAtaWQ9IjI1MTc1Ij48L3BhdGg+PC9zdmc+"> 隐藏内容 支付可见</div>
          <el-button class="btn btn-danger px-5 my-sm-0 btn-shadow" type="danger" @click="purchasingBut">立即购买</el-button>
        <br />
      </div>
      <div class="item-solid" v-if="hasPay">
        <div class="introduce " >
          <Editor
              v-model="formLabelAlign.privateContent"
              :defaultConfig="{readOnly :true}"
          />
        </div>
        <div v-if="formLabelAlign.attachments.length>0">
        <h2>附件：</h2>
        <el-row v-for="(item, index) in formLabelAlign.attachments" :key="index">
          <el-col :span="18" :md="19">
            <div> {{item.name}}</div>
          </el-col>
          <el-col :span="4">
            <el-button @click="downloadfile(item)">下载</el-button>
          </el-col>
          <el-divider />
        </el-row>
        </div>
      </div>

      <hr/>
      <div class="col-lg-12 text-muted small" style="margin-bottom: 20px">
        <ul>
        <li>交易流程：商家制作的内容 用户在平台购买作品，选择支付宝或微信进行支付，支付成功后自动获取隐藏内容。</li>
        <li>售后服务：以上作品均由商家发布，如果作品存在疑问或争议请在上方头像处点击咨询商家，售前及售后服务由商家负责。</li>
        <li>注意事项：平台不对作品内容负责，仅提供交易服务支持，请自行甄别商品优劣。</li></ul>
      </div>
        </el-col>
        <el-col :md="24">
          <div v-if="shoppings.length>1" class="other-works">
            <div class="section-header">
              <h4>其他作品</h4>
            </div>
            <div class="works-scroll-container">
              <div class="works-scroll-wrapper">
                <div v-for="(item, index) in shoppings" :key="index" class="work-item">
                  <router-link :to="'/creation/'+item.id" class="work-link">
                  <div class="work-image-container">
                    <img :src="item.cover" class="work-image" />
                  </div>
                  </router-link>
                  <div class="work-info">
                    <div class="position-tag">
                      ￥{{ item.amt }}
                    </div>
                    <div class="title">{{item.title}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="comments-section">
        <div class="section-header">
          <h3>评论区 <span class="count">({{total}})</span></h3>
        </div>

        <!-- 评论列表 -->
        <div class="comments-list" 
          v-infinite-scroll="loadMore" 
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
          infinite-scroll-immediate="false"
        >
          <div class="comment-item" v-for="comment in comments" :key="comment.id">
            <div class="comment-main">
              <div class="comment-header">
                <div class="comment-user-info">
                  <el-avatar :src="comment.userAvatar" :size="40"></el-avatar>
                  <div class="user-meta">
                    <span class="username">{{comment.userName}}</span>
                    <span class="time">{{comment.createTime}}</span>
                  </div>
                </div>
              </div>
              <div class="comment-content">
                <div class="text">{{comment.content}}</div>
                <!-- 评论图片 -->
                <div class="image-list" v-if="comment.images">
                  <el-image 
                    v-for="(img, imgIndex) in formatImages(comment.images)" 
                    :key="imgIndex"
                    :src="img"
                    fit="cover"
                    :preview-src-list="formatImages(comment.images)"
                  ></el-image>
                </div>
                <!-- 评论操作 -->
                <div class="comment-actions">
                  <span class="action-btn" @click="handleReply(comment)">
                    <i class="el-icon-chat-dot-round"></i> 回复
                  </span>
                  <span class="action-btn delete" 
                        v-if="comment.createBy === userStore.userInfo.id || formLabelAlign.createBy === userStore.userInfo.id"
                        @click="deleteComment(comment.id)">
                    <i class="el-icon-delete"></i> 删除
                  </span>
                </div>
              </div>
            </div>

            <!-- 回复列表 -->
            <div class="replies-list" v-if="comment.replies && comment.replies.length">
              <div class="reply-item" v-for="reply in comment.replies" :key="reply.id">
                <div class="comment-header">
                  <div class="comment-user-info">
                    <el-avatar :src="reply.userAvatar" :size="32"></el-avatar>
                    <div class="user-meta">
                      <span class="username">{{reply.userName}}</span>
                      <span class="reply-to" v-if="reply.replyToUserName">
                        回复 <span class="reply-name">@{{reply.replyToUserName}}</span>
                      </span>
                      <span class="time">{{reply.createTime}}</span>
                    </div>
                  </div>
                </div>
                <div class="reply-content">
                  <div class="text">{{reply.content}}</div>
                  <!-- 回复图片 -->
                  <div class="image-list" v-if="reply.images">
                    <el-image 
                      v-for="(img, imgIndex) in formatImages(reply.images)" 
                      :key="imgIndex"
                      :src="img"
                      fit="cover"
                      :preview-src-list="formatImages(reply.images)"
                    ></el-image>
                  </div>
                  <!-- 回复操作 -->
                  <div class="reply-actions">
                    <span class="action-btn" @click="handleReply(comment, reply)">
                      <i class="el-icon-chat-dot-round"></i> 回复
                    </span>
                    <span class="action-btn delete"
                          v-if="reply.createBy === userStore.userInfo.id || formLabelAlign.createBy === userStore.userInfo.id"
                          @click="deleteComment(reply.id)">
                      <i class="el-icon-delete"></i> 删除
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 加载状态 -->
          <div class="load-more" v-if="loading">
          </div>

          <!-- 空状态 -->
          <div class="empty-state" v-if="comments.length === 0 && !loading">
            暂无评论，快来抢沙发吧~
          </div>
        </div>
        <!-- 图片预览 -->
        <div class="image-preview" v-if="commentImages.length">
          <div class="preview-item" v-for="(img, index) in commentImages" :key="index">
            <el-image :src="img" fit="cover"></el-image>
            <div class="delete-btn" @click="deleteCommentImage(index)">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </div>
        <!-- 评论输入框 -->
        <div class="comment-input" :class="{ 'reply-mode': replyTo }">
          <div class="input-wrapper">
            <div class="reply-info" v-if="replyTo">
              <span>回复 {{replyTo.userName}}</span>
              <i class="el-icon-close" @click="cancelReply"></i>
            </div>
            <el-input
                type="textarea"
                v-model="commentText"
                class="comment-textarea"
                :rows="3"
                :placeholder="replyTo ? `回复 ${replyTo.userName}...` : '说点什么...'"
                maxlength="200"
                show-word-limit
            ></el-input>

            <!-- 图片上传 -->
            <div class="action-bar">
              <el-upload
                  :action="action"
                  :show-file-list="false"
                  :on-success="onUploadSuccess"
                  :before-upload="beforeUpload"
                  accept="image/*"
                  multiple
              >
                <i class="el-icon-picture"></i>
              </el-upload>
              <el-button
                  type="primary"
                  size="small"
                  @click="submitComment"
                  :disabled="!commentText.trim() && !commentImages.length"
              >发送</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Pay ref="pay" @paySuccess="paySuccess"></Pay>
      <UserInfo ref="userInfo"></UserInfo>
  </div>
</template>
<script>
import Pay from "@/components/common/Pay.vue";
import UserInfo from "@/components/common/UserInfo.vue";
import HeadNav from "@/components/common/HeadNav.vue";
import NavHeader from "@/components/layout/NavHeader.vue";
import {Editor} from "@wangeditor/editor-for-vue";
import Qrcode from "@/components/Qrcode/index.vue";
let loading=null;
const isMobileDevice=() =>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检查用户代理字符串
  return /android|iPhone|iPad|iPod|windows phone|blackberry|iemobile|opera mini/i.test(userAgent);
}
export default {
  components: {Qrcode, Editor, NavHeader, UserInfo, Pay,HeadNav},
  computed: {
    hasLogin(){
      return this.userStore?.userInfo.id ||sessionStorage.getItem("accessToken")
    }
  },
  watch: {
    '$route' (to, from) {
      console.log('路由变化了！');
      console.log('从', from, '到', to);
      this.detail(to.params.id)
    }
  },
  data() {
    return {
      shoppings:[],
      action: process.env["VUE_APP_BASE_API2"]+'/system/image/upload',
      showUser:false,
      hasPay:false,
      pos: {
        x: '40',
        y: '40',
      },
      userInfo: '',
      formLabelAlign: {
        title: '',
        amt: '',
        cover: '',
        publicContent:"",
        privateContent:'',
        attachments:[],
        id:'',
        excerpt:'',
        createBy:''
      },
      comments: [],
      commentText: '',
      commentImages: [],
      replyTo: null,
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      finished: false,
      maxImages: 9 // 最大图片数量限制
    };
  },
  mounted(){
    if(isMobileDevice()) location.href= process.env["VUE_APP_SHARE_BASE"]+"/h5/#/pages/creation/detail?id="+this.$route.params.id;
    if( this.$route.query.mchOrderNo){
      this.paySuccess(this.$route.query.mchOrderNo)
      return;
    }
    if(!this.$route.params.id) return
    if( localStorage.getItem(this.$route.params.id)){
      this.paySuccess(localStorage.getItem(this.$route.params.id))
      return;
    }
    this.detail(this.$route.params.id)
    this.loadComments()
  },
  methods: {
    detail(id){
      this.$http2({
        url: `/preview/${id}`,
        method: 'get'
      }).then((res) => {
        this.formLabelAlign=res.data;
        if(this.formLabelAlign.attachments){
          this.filelist=this.formLabelAlign.attachments;
        }
        console.log(res)
        if(res.data.tags!=null &&   res.data.tags!==''){
          this.formLabelAlign.tags=res.data.tags.split(",")
        }
        console.log( this.formLabelAlign.tags)
        this.loadUserInfo(this.formLabelAlign.createBy);
        this.other(this.formLabelAlign.createBy)
      })
    },
    other(createBy){
      this.$http2({
        method: 'get',
        url: `/creation/explore?createBy=${createBy}`
      }).then((res) => {
        this.shoppings=res.rows
      }).catch(function (error) {
        console.log(error)
      })
    },
    saveOrder(){
      if(!this.hasLogin){
        window.$showLogin({
          success: () => {
            if(this.formLabelAlign.id){
              this.$http2({
                url: `/klgeek/order/update`,
                method: 'put',
                data:{mchOrderNo:localStorage.getItem(this.formLabelAlign.id)}
              }).then((res) => {
                localStorage.removeItem(this.formLabelAlign.id)
                this.$router.push("/order");
              })
            }else {
              this.$router.push("/order");
            }
          },
          cancel: () =>{
            console.log("登录cancel")
          }
        });
      }else {
        this.$router.push("/order");
      }


    },
    ifShow(){
      if(!this.hasLogin)
      {
        window.$showLogin({
          success: () => {
            console.log("登录成功")
          },
          cancel: () =>{
            console.log("登录cancel")
          }
        });
        return
      }
      let left = this.$elm.fixLeft(this.$refs.item);
      let top = this.$elm.fixTop(this.$refs.item);
      let pos = {
        x: left + 50,
        y: top
      };
      this.$refs.userInfo.open(this.userInfo,pos)
    },
    loadUserInfo(userId) {
      this.$http2({
        url: `/im/user/${userId}`,
        method: 'get'
      }).then((user) => {
        this.userInfo = user.data;
      })
    },
    showUserInfo() {
        let left = this.$elm.fixLeft(this.$refs.item);
        let top = this.$elm.fixTop(this.$refs.item);
        let pos = {
          x: left + 50,
          y: top
        };
        this.$refs.userInfo.open(this.userInfo,pos)
    },
    async downloadfile(file){
      try {
        const response = await fetch(file.url);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = file.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // 清理创建的对象URL
      } catch (error) {
        console.error("下载文件失败:", error);
      }
    },
    paySuccess(mchOrderNo){
      this.$http2({
        url: `/pay/getConent?mchOrderNo=${mchOrderNo}`,
        method: 'get'
      }).then((res) => {
        this.formLabelAlign=res.data;
        if(this.formLabelAlign.attachments){
          this.filelist=this.formLabelAlign.attachments;
        }
        this.hasPay=true;
        this.loadUserInfo(this.formLabelAlign.createBy);
        if(!this.hasLogin)
        localStorage.setItem(this.formLabelAlign.id,mchOrderNo);
      })
    },
    purchasingBut(){
      this.$refs.pay.openPay(this.formLabelAlign.id,"creation");
    },
    // 格式化图片数组
    formatImages(images) {
      if (!images) return []
      return typeof images === 'string' ? images.split(',') : images
    },

    // 加载更多
    loadMore() {
      if (this.loading || this.finished) return
      this.loadComments()
    },

    // 加载评论列表
    async loadComments(refresh = false) {
      if (refresh) {
        this.page = 1
        this.comments = []
        this.finished = false
      }
      
      if (this.loading || this.finished) return
      this.loading = true
      
      try {
        const res = await this.$http2({
          url: `/klgeek/comment/list/${this.$route.params.id}`,
          method: 'get',
          params: {
            pageNum: this.page,
            pageSize: this.pageSize,
            busType:"creation"
          }
        })
        
        const { rows, total } = res
        this.total = total
        
        if (refresh) {
          this.comments = rows
        } else {
          this.comments = [...this.comments, ...rows]
        }
        
        // 判断是否加载完所有数据
        this.finished = this.comments.length >= total
        this.page++
        
      } catch (error) {
        console.error('获取评论失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 提交评论
    async submitComment() {
      if (!this.hasLogin) {
        window.$showLogin()
        return
      }
      if (!this.commentText.trim() && !this.commentImages.length) {
        this.$message.warning('请输入评论内容或上传图片')
        return
      }
      try {
        const params = {
          creationId: this.formLabelAlign.id,
          content: this.commentText,
          images: this.commentImages.join(","),
          userName: this.userStore.userInfo.nickName,
          userAvatar: this.userStore.userInfo.headImageThumb,
          createBy:this.formLabelAlign.createBy,
          busType:"creation"
        }
        
        if (this.replyTo) {
          params.parentId = this.replyTo.commentId
          params.replyUserId = this.replyTo.userId
          params.replyToUserName = this.replyTo.replyToUserName
        }
        console.log(params)
        await this.$http2({
          url: '/klgeek/comment',
          method: 'post',
          data: params
        })
        
        this.$message.success('评论成功')
        this.commentText = ''
        this.commentImages = []
        this.cancelReply()
        this.loadComments(true) // 刷新评论列表
      } catch (error) {
        this.$message.error(error)
      }
    },

    // 上传成功回调
    onUploadSuccess(response, file) {
      if (response.code === 200) {
        // 检查图片数量限制
        if (this.commentImages.length >= this.maxImages) {
          this.$message.warning(`最多只能上传${this.maxImages}张图片`)
          return
        }
        
        // 添加图片URL到数组
        this.commentImages.push(response.data.thumbUrl)
      } else {
        this.$message.error('图片上传失败')
      }
    },

    // 删除评论图片
    deleteCommentImage(index) {
      this.commentImages.splice(index, 1)
    },

    // 上传前检查
    beforeUpload(file) {
      // 检查图片数量
      if (this.commentImages.length >= this.maxImages) {
        this.$message.warning(`最多只能上传${this.maxImages}张图片`)
        return false
      }

      // 检查文件类型
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }

      // 检查文件大小（这里限制为5MB）
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB')
        return false
      }

      return true
    },

    // 处理回复
    handleReply(comment, reply = null) {
      if (!this.hasLogin) {
        window.$showLogin()
        return
      }

      this.replyTo = {
        commentId: reply ? comment.id : comment.id,
        userId: reply ? reply.createBy : comment.createBy,
        userName: reply ? reply.userName : comment.userName,
        replyToUserName: reply?.userName 
      }
      
      // 聚焦到评论输入框
      this.$nextTick(() => {
        const textarea = this.$el.querySelector('.el-textarea__inner')
        console.log(textarea)
        if (textarea) {
          textarea.focus()
        }
      })
    },

    // 取消回复
    cancelReply() {
      this.replyTo = null
      this.commentText = ''
    },

    // 删除评论
    async deleteComment(commentId) {
      try {
        await this.$confirm('确定要删除这条评论吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        await this.$http2({
          url: `/klgeek/comment/${commentId}`,
          method: 'delete'
        })
        
        this.$message.success('删除成功')
        // 刷新评论列表
        this.loadComments(true)
        
      } catch (error) {
        if (error !== 'cancel') { // 忽略取消操作的报错
          this.$message.error('删除失败')
          console.error('删除评论失败:', error)
        }
      }
    }
  },
}
</script>

<style scoped lang="scss">
// 基础样式类
.text-danger {
  color: #dc3545 !important;
}

.text-muted {
  color: #6c757d !important;
}

.small, small {
  font-size: 80%;
  font-weight: 400;
}

// 警告框样式
.alert-danger {
  position: relative;
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.375rem;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
  
  h5 {
    margin: 0 0 0.5rem 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #721c24;
  }
  
  .el-button {
    margin-left: 0.5rem;
  }
  
  marquee {
    color: #721c24;
    font-size: 0.9rem;
    margin-top: 0.5rem;
  }
}

// 边框样式
.border-light {
  border: 1px solid #dee2e6 !important;
}

// 支付成功区域特殊样式
.alert-danger.border-light {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  border-color: #c3e6cb;
  color: #155724;
  
  h5 {
    color: #155724;
  }
  
  marquee {
    color: #155724;
  }
  
  .el-button {
    background-color: #28a745;
    border-color: #28a745;
    
    &:hover {
      background-color: #218838;
      border-color: #1e7e34;
    }
  }
}

// 价格显示样式
.text-danger h4 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 1px 2px rgba(220, 53, 69, 0.1);
  
  &::before {
    font-size: 1.5rem;
    margin-right: 0.25rem;
    opacity: 0.8;
  }
}

// 隐藏内容提示样式
.pb-2 {
  padding-bottom: 0.5rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

// 购买按钮样式
.btn-danger {
  background-color: #dc3545;
  border-color: #dc3545;
  color: #fff;
  font-weight: 600;
  padding: 0.75rem 2rem;
  border-radius: 0.375rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.2);
  
  &:hover {
    background-color: #c82333;
    border-color: #bd2130;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(220, 53, 69, 0.2);
  }
}

.btn-shadow {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

// 响应式适配
@media (max-width: 768px) {
  .alert-danger {
    padding: 0.75rem;
    
    h5 {
      font-size: 1rem;
    }
  }
  
  .text-danger h4 {
    font-size: 1.5rem;
  }
  
  .btn-danger {
    padding: 0.5rem 1.5rem;
    font-size: 0.9rem;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  max-width: 100%;
  display: block;
}
.item-solid{
  border: 1px dashed #FF9A9A;font-size: 1em;
  overflow:hidden;
  padding: 2rem!important
}
.el-carousel__item:nth-child(2n) {
}

.el-carousel__item:nth-child(2n+1) {
}

.other-works {
  margin-top: 20px;
  width: 100%;
}

.works-scroll-container {
  overflow-x: scroll;
  width: 100%;
  padding: 10px 0;
  -webkit-overflow-scrolling: touch;
}

.works-scroll-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: max-content;
  gap: 15px;
}

.work-item {
  flex: 0 0 auto;
  width: 200px;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.work-image-container {
  width: 100%;
  height: 180px; /* 固定图片容器高度 */
  overflow: hidden;
  position: relative;
}

.work-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持图片比例并填充容器 */
  object-position: center; /* 居中显示图片 */
}

.work-info {
  padding: 8px 0;
  flex: 1;
}

/* 美化滚动条 */
.works-scroll-container::-webkit-scrollbar {
  height: 8px;
  display: block;
}

.works-scroll-container::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 4px;
}

.works-scroll-container::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  border-radius: 4px;
}

.float-sidebar {
  position: fixed;
  right: 40px;
  top: 40%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 99;

  .sidebar-item {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    }
  }

  .qrcode-box {
    width: 140px;
    
    .qr-image {
      width: 120px;
      height: 120px;
      margin-bottom: 8px;
    }
    
    .qr-text {
      font-size: 14px;
      color: #333;
      margin-bottom: 4px;
      font-weight: 500;
    }
    
    .qr-desc {
      font-size: 12px;
      color: #999;
    }
  }

  .share-box {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 12px 20px;
    color: #666;
    font-size: 14px;
    
    i {
      font-size: 16px;
    }
  }
}

// 响应式适配
@media screen and (max-width: 768px) {
  .float-sidebar {
    position: fixed;
    right: 16px;
    bottom: 20px;
    top: auto;
    transform: none;
    flex-direction: row;
    gap: 12px;

    .qrcode-box {
      width: 120px;
      padding: 12px;
      
      .qr-image {
        width: 100px;
        height: 100px;
      }
    }

    .share-box {
      padding: 8px 16px;
    }
  }
}

.meta-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 8px 0;
}

.tags-wrapper {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  
  .tag-item {
    margin: 0;
    font-size: 12px;
    border-radius: 4px;
    padding: 0 8px;
    height: 24px;
    line-height: 22px;
    background: #f4f4f5;
    border-color: #e9e9eb;
    color: #606266;
    
    &:hover {
      transform: translateY(-1px);
      transition: transform 0.2s ease;
    }
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .meta-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .tags-wrapper {
    margin-left: 0;
  }
}

.comments-list {
  max-height: 600px; // 设置最大高度以启用滚动
  overflow-y: auto; // 启用垂直滚动
  
  // 隐藏滚动条但保持功能（可选）
  &::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;

  .preview-item {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 4px;
    overflow: hidden;

    .el-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .delete-btn {
      position: absolute;
      top: 4px;
      right: 4px;
      width: 20px;
      height: 20px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      i {
        color: #fff;
        font-size: 12px;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.7);
      }
    }
  }
}

.comment-item {
  margin-bottom: 24px;
  
  .comment-main {
    margin-bottom: 20px;
    
    .comment-header {
      margin-bottom: 12px;
      
      .comment-user-info {
        display: flex;
        align-items: center;
        gap: 12px;
        
        .user-meta {
          display: flex;
          align-items: center;
          gap: 12px;
          
          .username {
            font-size: 14px;
            font-weight: 500;
            color: #333;
            line-height: 1;
          }
          
          .time {
            font-size: 12px;
            color: #999;
            line-height: 1;
          }
        }
      }
    }
    
    .comment-content {
      padding-left: 52px; // 头像宽度(40px) + 间距(12px)
      
      .text {
        font-size: 14px;
        color: #333;
        line-height: 1.6;
      }
    }
  }
  
  // 回复列表样式
  .replies-list {
    margin-top: 16px;
    margin-left: 52px; // 与主评论内容对齐
    padding-left: 16px; // 添加左侧内边距
    border-left: 2px solid #f0f0f0; // 添加左侧边框线
    
    .reply-item {
      margin-bottom: 16px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .comment-header {
        margin-bottom: 8px;
        
        .comment-user-info {
          display: flex;
          align-items: center;
          gap: 8px;
          
          .user-meta {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px;
            
            .username {
              font-size: 14px;
              font-weight: 500;
              color: #333;
            }
            
            .reply-to {
              font-size: 14px;
              color: #666;
              
              .reply-name {
                color: #409EFF;
              }
            }
            
            .time {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }
      
      .reply-content {
        padding-left: 40px; // 头像宽度(32px) + 间距(8px)
        
        .text {
          font-size: 14px;
          color: #333;
          line-height: 1.6;
        }
      }
    }
  }
}

.comment-actions,
.reply-actions {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 16px;
  
  .action-btn {
    display: inline-flex;
    align-items: center;
    font-size: 13px;
    color: #8c8c8c;
    cursor: pointer;
    padding: 4px 0;
    
    i {
      margin-right: 4px;
      font-size: 14px;
    }
    
    &:hover {
      color: #409EFF;
    }
    
    &.delete {
      &:hover {
        color: #F56C6C;
      }
    }
  }
}

// 回复列表中的操作按钮稍微小一点
.reply-actions {
  .action-btn {
    font-size: 12px;
    
    i {
      font-size: 13px;
    }
  }
}

.comment-input {
  background: #fff;
  padding: 20px;
  border-top: 1px solid #f5f5f5;
  
  &.reply-mode {
    padding-top: 10px;
  }
  
  .input-wrapper {
    .reply-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 0;
      color: #666;
      font-size: 13px;
      
      i {
        cursor: pointer;
        &:hover {
          color: #409EFF;
        }
      }
    }
  }
}

// 评论图片列表样式
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  
  .el-image {
    width: 100px;
    height: 100px;
    border-radius: 4px;
    cursor: pointer;
    
    &:hover {
      opacity: 0.9;
    }
  }
}

// 回复列表中的图片稍微小一点
.replies-list {
  .image-list {
    .el-image {
      width: 80px;
      height: 80px;
    }
  }
}
</style>